/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const laboratoryDepartments = sqliteTable('laboratory_departments', {
  id: text('id').primaryKey().notNull(),
  org_id: text('org_id'),
  code: text('code'),
  name: text('name'),
  description: text('description'),
  sort_order: integer('sort_order'),
  active: integer('active'),
  created_at: text('created_at'),
  updated_at: text('updated_at'),
});
